<template>
  <v-main>
    <v-container>
  <p v-if="nowname">今の名前：{{currentName}}</p>
  <p v-if="uid">今のuid：{{uid}}</p>
  <p v-if="email">今のEmail：{{email}}</p>
  <p v-if="!nowname" style="color:red">あなたは名前が未設定です。</p>
  <p>新しい名前入力↓</p><v-text-field v-model="newname" placeholder="新しい名前" solo></v-text-field>
  <v-btn @click="update" :disabled="newname.length>0">名前を設定する</v-btn>

    </v-container>
  </v-main>
</template>

<script>
import firebase from "firebase"
export default {
  name: 'App',
  data() {
    return {
      newname:"",
      db: null
    }
  },
  mounted(){
    this.db = firebase.firestore()
    this.newname = this.currentName 
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
  },
  methods: {
    update(){
      let self = this
      this.$store.dispatch('auth/updateName', this.newname)
      this.db.collection("0").doc("config").collection("members").doc(self.uid).update({
        name: self.newname
      }).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        //console.log("Firebseユーザ登録完了")
        //self.getMembers()
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Firebaseユーザ登録失敗: ", error)
        alert("Error!:"+error)
      }) 
    }
  }
}
</script>